import React, { FC, useCallback, useState } from 'react';
import { CandidateLayout } from '../../layout/candidate/CandidateLayout';
import { useForm } from 'antd/lib/form/Form';
import { TextBlock } from '../../uicomp/atmos/content-block/ContentBlock';
import { Form, FormSchema, SchemaFormItems } from '../../components/form/Form';
import { Button, message } from 'antd';
import { useConnection } from '../../connection/Application';
import styles from './signup.module.less';
import { useRouter } from 'next/router';

const schema: FormSchema = [
  {
    id: 'currentPassword',
    type: 'password',
    name: 'Current Password',
    props: { placeholder: 'Enter your current password' },
    options: {
      rules: [{ required: true, message: 'Current password is required' }],
    },
  },
  {
    id: 'password',
    type: 'password',
    name: 'New Password',
    props: { placeholder: 'Enter your new password' },
    options: {
      rules: [
        { required: true, message: 'New password is required' },
        {
          validator: 'passwordPolicy',
          message:
            'Password should contain more than 8 characters and at least 1 upper case character, ' +
            '1 lower case character, 1 number and 1 special character',
        },
      ],
    },
  },
  {
    id: 'confirmPassword',
    type: 'password',
    name: 'Confirm Password',
    props: { placeholder: 'Confirm your Password' },
    options: {
      dependencies: ['password'],
      rules: [
        { required: true, message: 'Please confirm your password.' },
        {
          validator: 'equals',
          to: 'password',
          message: 'Your password and confirm password does not match',
        },
      ],
    },
  },
];

export const ChangePasswordPage: FC = () => {
  const [form] = useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const connection = useConnection();
  const history = useRouter();

  const handleSubmit = useCallback(
    (value) => {
      setLoading(true);
      const { currentPassword, password: newPassword } = value;
      connection
        .post('auth/password/change', { currentPassword, newPassword })
        .then(() => {
          form.resetFields();
          message.success('Password Changed.');
          history.push('/');
        })
        .catch(() => {
          form.setFields([
            { name: 'currentPassword', errors: ['Invalid password'] },
            { name: 'password', errors: [' '] },
            { name: 'confirmPassword', errors: [' '] },
          ]);
        })
        .finally(() => {
          form.resetFields();
          setLoading(false);
        });
    },
    [connection, form, history],
  );
  return (
    <CandidateLayout title={'Reset Password'}>
      <div className={styles.ChangePassword}>
        <div className={styles.passwordContainer}>
          <TextBlock heading level={1} align={'center'}>
            Change Password
          </TextBlock>
          <Form form={form} onFinish={handleSubmit} layout="vertical" style={{ marginTop: 34 }}>
            <SchemaFormItems schema={schema} />
            <Button
              style={{ marginTop: 40, fontSize: 20 }}
              htmlType="submit"
              type="primary"
              block
              loading={loading}>
              Change Password
            </Button>
          </Form>
        </div>
      </div>
    </CandidateLayout>
  );
};
